/**
 * Created by Simon Zhao on 7/21/21.
 * Description:
 * The button component for adding configuration sections.
 * ------ maintenance history ------
 */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { createSelector, select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from '../../../redux';
import { GetTemplateFields } from '../../../redux/actions/template-web.actions';
import { singleTemplateFieldsByIdSelector, templateFieldsSelector } from '../../../redux/reducers/template-fields.reducer';
import { TemplateField } from '../../../tamalelibs/models/template-field.model';
import { entityTemplatesSelector, entryTemplatesSelector } from '../../../tamalelibs/redux/template.reducer';

@Component({
    selector: 'mdl-dialog-section-add-button',
    templateUrl: './mdl-dialog-section-add-button.component.html',
    styleUrls: ['./mdl-dialog-section-add-button.component.scss']
})
export class MdlDialogSectionAddButtonComponent implements OnInit, OnDestroy {
    @Output() fieldSelected = new EventEmitter<TemplateField>();

    @Input()
    set fieldsInUse(v: string[]) {
        if (v && v !== this._fieldsInUse) {
            this._fieldsInUse = v;
            this._determineCandidates();
        }
    }

    @Input() typeId = '';

    defaultEmptyItem: TemplateField = new TemplateField();

    fieldCandidates: Array<TemplateField> = [];

    get fieldsInUse(): string[] {
        return this._fieldsInUse;
    }


    private _availableFields: Array<TemplateField> = [];

    private _fieldsInUse: string[] = [];

    private _suscriptions: Subscription[] = [];

    constructor(private _store: Store<AppState>) { }

    ngOnInit() {
        this._suscriptions.push(
            this._store.pipe(
                select(singleTemplateFieldsByIdSelector, { id: this.typeId })).subscribe(
                    (fields: Array<TemplateField>) => {
                        if (fields && fields.length > 0) {
                            this._availableFields = fields;
                            this._determineCandidates();
                        }
                    }));
    }

    ngOnDestroy() {
        this._suscriptions.forEach(subscription => subscription.unsubscribe());
    }

    onFieldClick(selected: TemplateField) {
        this.fieldSelected.emit(selected);
    }

    private _determineCandidates() {
        this._availableFields.sort(
            (a: TemplateField, b: TemplateField) => a.label.localeCompare(b.label)
        );

        this.fieldCandidates = [...this._availableFields];
        this.fieldsInUse.forEach(fInUse => this.fieldCandidates.splice(this.fieldCandidates.findIndex(f => f.controlID === fInUse), 1));
    }
}
